/* eslint-disable no-restricted-imports */
// This is the ONLY place where we import Route directly
import { ReactElement } from "react";
import { Route as ReactRouterRoute, RouteComponentProps } from "react-router-dom";

import styled from "styled-components";

import { Error404 } from "./component/error-404";
import { useLegalMode } from "./current-legal-entity-provider";
import { LEGAL_MODE_LABEL, LegalMode } from "./services_v2/common/types";

const Error404Container = styled.div`
  text-align: -webkit-center;
`;

/**
 * an overload of Route
 * Will check that the current legal entity mode allow to access this Route
 */
export const Route = ({
  path,
  legalModes,
  hiddenForSandbox,
  exact,
  render,
  component,
}: {
  path: string;
  legalModes: LegalMode[];
  hiddenForSandbox?: boolean;
  exact?: boolean;
  render?: (any) => ReactElement;
  component?: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
}): ReactElement | null => {
  const { mode, isSandbox } = useLegalMode();
  if (!legalModes.includes(mode)) {
    return (
      <Error404Container>
        <Error404 mainText={`Cette page n'est pas accessible en mode ${LEGAL_MODE_LABEL[mode]}.`} />
      </Error404Container>
    );
  }
  if (hiddenForSandbox && isSandbox) {
    return (
      <Error404Container>
        <Error404 mainText={"Cette page n'est pas accessible pour une entreprise de démo."} />
      </Error404Container>
    );
  }

  return <ReactRouterRoute exact={exact} path={path} render={render} component={component} />;
};
